import {ReadMore} from './ReadMore'
(function() {
    const $rmAll = document.querySelectorAll('.readmore')
    $rmAll.forEach($rm => new ReadMore.RM($rm))
})()
